export class NotificationCounter {
    private static key = "notification_count";

    static getCount(): number {
        return parseInt(localStorage.getItem(this.key) || "0", 10);
    }

    static increment(): number {
        const newCount = this.getCount() + 1;
        localStorage.setItem(this.key, newCount.toString());
        return newCount;
    }

    static decrement(): number {
        const newCount = this.getCount() > 0 ? this.getCount() - 1 : 0;
        localStorage.setItem(this.key, newCount.toString());
        return newCount;
    }

    static clear(): void {
        localStorage.setItem(this.key, "0");
    }
}
